import React from 'react'

export const IntroCircleImg = props => {
  return(
    <div className="intro intro-img" onClick={props.onClick} >
      
    </div>
  )
}